// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"de209bb7","977":"6907b5bc"}[chunkId] + ".chunk.js";
};